import { PdfViewerDao } from '../dao/PdfViewerDao';

export class PdfViewerBusiness {
    static async validatePermission(solicitudId) {
        return PdfViewerDao.validatePermission(solicitudId);
    }

    static async getDocumentReader(solicitudId) {
        return PdfViewerDao.getDocumentReader(solicitudId);
    }

    static async getDocumentReaderStatus(solicitudId) {
        return PdfViewerDao.getDocumentReaderStatus(solicitudId);
    }

    static async postDocumentReaderStatus(data, solicitudId) {
        return PdfViewerDao.postDocumentReaderStatus(data, solicitudId);
    }

    static async sendDocumentReader(dataFile, solicitudId) {
        return PdfViewerDao.sendDocumentReader(dataFile, solicitudId);
    }
}
